import { useTranslation } from "react-i18next";
import { useTranslationResolver } from "app/hooks/useTranslationResolver";

const isTitleKey = (value: string) => /^sp\.forms\.[a-z0-9_-]+\.title$/i.test(value);

export const resolveFormTitle = (title: string | null | undefined, name: string | null | undefined, current?: string, other?: string): string => {
    const raw = String(title || "");
    if (!isTitleKey(raw)) return raw || String(name || "");
    return current || other || String(name || "") || "Untitled form";
};

export const useFormTitleTranslations = (keys: string[]) => {
    const { t, i18n } = useTranslation();
    const language = (i18n?.resolvedLanguage || i18n?.language || "en-US").startsWith("pt") ? "pt-BR" : "en-US";
    const otherLanguage = language === "pt-BR" ? "en-US" : "pt-BR";
    const titleKeys = keys.filter(isTitleKey);
    const current = useTranslationResolver(titleKeys, language);
    const other = useTranslationResolver(titleKeys, otherLanguage);
    return (title?: string | null, name?: string | null) => {
        const key = String(title || "");
        const bundled = key && t(key);
        return resolveFormTitle(title, name, current.data?.[key] || (bundled !== key ? String(bundled) : undefined), other.data?.[key]);
    };
};
